import { render, staticRenderFns } from "./VideoShare.vue?vue&type=template&id=c69af4f6&scoped=true"
import script from "./VideoShare.vue?vue&type=script&lang=js"
export * from "./VideoShare.vue?vue&type=script&lang=js"
import style0 from "./VideoShare.vue?vue&type=style&index=0&id=c69af4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69af4f6",
  null
  
)

export default component.exports